import { Modal } from "./modal";

class Share {
  constructor() {
    this.shareButton = $(".js-snsShare").first();
    this.shareContent = {
      url: this.shareButton.data("shareUrl"),
      text: this.shareButton.data("shareText"),
    };

    if (this.useNavigatorShare()) {
      this.shareButton.on("click", () => navigator.share(this.shareContent));
    } else {
      new Modal();
    }
  }

  useNavigatorShare () {
    return this.isIosOrAndroid() &&
           navigator.canShare &&
           navigator.canShare(this.shareContent);
  }

  isIosOrAndroid () {
    return /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent||navigator.vendor||window.opera);
  }
}

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const share = new Share();
  }, false);
})();
